import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {Partner} from "../../../shared/interface/partner";
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {ReplaySubject} from "rxjs";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormHelperService} from "../../../shared/services/form-helper.service";
import {PartnerService} from "../../../shared/services/partner.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {HttpErrorResponse} from "@angular/common/http";

export interface UpdateCurrentDynamicsDialogData {
  partnerObject: Partner;
}

@Component({
  selector: 'app-update-current-dynamics-dialog',
  templateUrl: './update-current-dynamics-dialog.component.html',
  styleUrls: ['./update-current-dynamics-dialog.component.scss']
})
export class UpdateCurrentDynamicsDialogComponent implements OnInit, OnDestroy {

  dynamicsForm: FormGroup;
  currentDynamicsControl: FormControl;
  partnerObject: Partner;
  formErrors = {};
  processingRequest = false;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    public dialogRef: MatDialogRef<UpdateCurrentDynamicsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: UpdateCurrentDynamicsDialogData,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private partnerService: PartnerService,
    private snack: MatSnackBar,
  ) {
    this.partnerObject = data.partnerObject;
    this.dynamicsForm = fb.group({
      currentDynamics: this.currentDynamicsControl = fb.control(this.partnerObject.currentDynamics),
    });
  }

  ngOnInit(): void {

  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  sendForm(): void {
    this.processingRequest = true;
    this.formHelper.removeBackendErrorState(this.dynamicsForm, this.formErrors);
    this.formErrors = {};

    this.partnerService.updateCurrentDynamics(this.dynamicsForm.value, this.partnerObject.uuid)
      .subscribe(() => {
        this.snack.open('Pomyślnie zaktualizowano obiekt partnera', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        this.dialogRef.close();
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;

        this.snack.open('Podczas aktualizacji obiektu partnera wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });

        if (error.status === 400) {
          this.formErrors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.dynamicsForm, this.formErrors);
        }
      })
    ;
  }
}
